import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MiscSensorInputGlyph = /*#__PURE__*/createElement("g", {
  id: "misc_sensor_input"
}, /*#__PURE__*/createElement("circle", {
  cx: 59.43,
  cy: 52.19,
  r: 3.44
}), /*#__PURE__*/createElement("path", {
  d: "M59.48 59.88c-4.24 0-7.68-3.45-7.68-7.68 0-2.22.97-4.33 2.63-5.79V27.57c0-2.78 2.27-5.05 5.05-5.05s5.05 2.27 5.05 5.05V46.4a7.694 7.694 0 012.63 5.79c.01 4.24-3.44 7.69-7.68 7.69zm0-34.36c-1.13 0-2.05.92-2.05 2.05v20.34l-.64.45c-1.25.88-2 2.31-2 3.83 0 2.58 2.1 4.68 4.68 4.68s4.68-2.1 4.68-4.68c0-1.52-.75-2.95-2-3.83l-.64-.45V27.57c.02-1.13-.9-2.05-2.03-2.05z"
}), /*#__PURE__*/createElement("path", {
  d: "M59.48 53.69c-.83 0-1.5-.67-1.5-1.5V38.45c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v13.74c0 .83-.67 1.5-1.5 1.5zm8.59 7.79H15.93c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h52.13c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.49 1.5z"
}), /*#__PURE__*/createElement("circle", {
  cx: 31.53,
  cy: 54.01,
  r: 3
}), /*#__PURE__*/createElement("path", {
  d: "M34.17 52.52l-3.28-1.48 3.05-4.78c.23-.38 1.81-2.9 2.21-2.72l.17.08c.4.18-.44 3.04-.58 3.46l-1.57 5.44z"
}), /*#__PURE__*/createElement("path", {
  d: "M46.16 60.68l-2.65-1.4c.95-1.8 1.43-3.76 1.43-5.81 0-6.87-5.59-12.46-12.46-12.46S20.02 46.6 20.02 53.47c0 2.01.46 3.92 1.37 5.69l-2.67 1.37a15.57 15.57 0 01-1.7-7.06c0-8.53 6.94-15.46 15.46-15.46s15.46 6.94 15.46 15.46c0 2.51-.62 5-1.78 7.21z"
}), /*#__PURE__*/createElement("path", {
  d: "M32.56 44.16c-.55 0-1-.45-1-1V40.8c0-.55.45-1 1-1s1 .45 1 1v2.36c0 .55-.45 1-1 1zm-7.53 3.29c-.26 0-.51-.1-.71-.29l-1.67-1.67a.996.996 0 111.41-1.41l1.67 1.67c.39.39.39 1.02 0 1.41-.18.19-.44.29-.7.29zm-2.81 6.41h-.09l-2.35-.21a.998.998 0 01-.91-1.08c.05-.55.53-.97 1.08-.91l2.35.21a.998.998 0 01-.08 1.99zm17.7-6.41c-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l1.67-1.67a.996.996 0 111.41 1.41l-1.67 1.67c-.18.19-.44.29-.7.29zm2.73 6.41c-.51 0-.95-.39-1-.91a.992.992 0 01.91-1.08l2.35-.21c.55-.05 1.04.36 1.08.91s-.36 1.04-.91 1.08l-2.35.21h-.08z"
}));
const MiscSensorInput = createSvg({
  name: 'misc_sensor_input',
  path: MiscSensorInputGlyph
});

export default MiscSensorInput;
export { MiscSensorInputGlyph };
